import React from "react";
import ReactDOM from "react-dom";
import "./DeleteWarningModal.scss";

export default function DeleteWarningModal({
  message,
  onConfirm,
  onClose,
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  type = "warning",
  position = "center", // 👈 new prop
}) {
  const overlayClass = `delete-warning-overlay position-${position}`;

  const node = (
    <div className={overlayClass} role="dialog" aria-modal="true">
      <div className="delete-warning-box" onClick={(e) => e.stopPropagation()}>
        <h3>{type === "info" ? "⚠️ Warning" : "🗑️ Confirm Deletion"}</h3>
        <p>{message}</p>
        <div className="delete-warning-actions">
          {type === "warning" && (
            <button className="delete-warning-btn confirm" onClick={onConfirm}>
              {confirmText}
            </button>
          )}
          <button className="delete-warning-btn cancel" onClick={onClose}>
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(node, document.body);
}
